import Teams from '../TeamsEnum';
import DatePicker from "react-datepicker";
import React, { useState } from 'react';

const Torneos = {
  LIGA_PROFESIONAL: "Liga Profesional Argentina",
  COPA_ARGENTINA: "Copa Argentina",
  COPA_SUDAMERICANA: "Copa Sudamericana",
  COPA_LIBERTADORES: "Copa Libertadores",
};

const NextLocalMatchForm = ({ formDataNextLocalMatch, onInputChange, onSubmit }) => {
  const [startDate, setStartDate] = useState(new Date());

  const handleChange = (date) => {
    setStartDate(date);
    const formattedDate = date.toLocaleDateString('en-GB');
    onInputChange({
      target: { name: 'date', value: formattedDate }
    });
  };

  const isFormValid = () => {
    const requiredFields = [
      'vsTeam',
      'date',
      'matchHours',
      'departureBusHours',
      'departurePlaceBus',
      'torneo',
    ];
    return requiredFields.every((field) => formDataNextLocalMatch[field]?.trim());
  };

  return (
    <form onSubmit={onSubmit}>

      <div className="mb-3 mt-3">
        <label htmlFor="torneo" className="form-label">
          Torneo
        </label>
        <select
          className="form-control"
          id="torneo"
          name="torneo"
          onChange={onInputChange}
          value={formDataNextLocalMatch.torneo}>
          <option value="" disabled>Seleccionar torneo</option>
          {Object.entries(Torneos).map(([key, value]) => (
            <option key={key} value={value}>{value}</option>
          ))}
        </select>
      </div>

      <div className="mb-3 mt-3">
        <label htmlFor="vsTeam" className="form-label">
          Versus
        </label>
        <select
          className="form-control"
          id="vsTeam"
          name="vsTeam"
          onChange={onInputChange}
          value={formDataNextLocalMatch.vsTeam}>
          <option value="" disabled>Seleccionar equipo</option>
          {Object.entries(Teams).map(([key, value]) => (
            <option key={key} value={value}>{value}</option>
          ))}
        </select>
      </div>

      <div className="mb-3 mt-3">
        <label htmlFor="date" className="form-label">
          Fecha
        </label>
        <DatePicker
          selected={startDate}
          onChange={handleChange}
          className="form-control"
          id="date"
          name="date"
          dateFormat="dd-MM-yyyy"
        />
      </div>

      <div className="mb-3">
        <label htmlFor="matchHours" className="form-label">
          Hora Partido
        </label>
        <input
          type="time"
          className="form-control"
          id="matchHours"
          name="matchHours"
          onChange={onInputChange}
          value={formDataNextLocalMatch.matchHours}
        />
      </div>

      <div className="mb-3">
        <label htmlFor="departureBusHours" className="form-label">
          Hora Salida Micro
        </label>
        <input
          type="time"
          className="form-control"
          id="departureBusHours"
          name="departureBusHours"
          onChange={onInputChange}
          value={formDataNextLocalMatch.departureBusHours}
        />
      </div>

      <div className="mb-3">
        <label htmlFor="departurePlaceBus" className="form-label">
          Lugar Salida Micro
        </label>
        <input
          type="text"
          className="form-control"
          id="departurePlaceBus"
          name="departurePlaceBus"
          onChange={onInputChange}
          value={formDataNextLocalMatch.departurePlaceBus}
        />
      </div>

      <div className="mb-3">
        <label htmlFor="arrivalPlaceBus" className="form-label">
          Lugar de Llegada Micro
        </label>
        <input
          type="text"
          className="form-control"
          id="arrivalPlaceBus"
          name="arrivalPlaceBus"
          onChange={onInputChange}
          value={formDataNextLocalMatch.arrivalPlaceBus}
        />
      </div>

      <button
        type="submit"
        style={{
          backgroundColor: '#C73B33',
          borderColor: '#FF5733',
          color: '#FFF',
        }}
        className="btn"
        disabled={!isFormValid()}>
        Crear Próximo Viaje a ver al Rojo
      </button>

    </form>
  );
};

export default NextLocalMatchForm;
